import { CheckOutlined } from '@mui/icons-material';
import { Box, Card, CardContent, CardHeader, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import ListItemText from '@mui/material/ListItemText';
import { t } from 'i18next';
import React, { Component } from 'react';
import { NavLink } from 'react-router-dom';
import { getFlag } from '../commons/Utils';
import SkeletonList from '../elements/SkeletonListAvatar';
import api from '../services/api';

class DeskMzAllocationDetails extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      data: [],
      allowed: true,
    }
  }

  componentDidMount() {
    this.setState({ isLoading: true })

    api.get('v2/mz/wa/composition_details/' + this.props.idPortfolio)
      .then(response => {
        const data = response.data
        this.setState({ data });
        this.setState({ isLoading: false })
      }).catch(error => {
        console.log(error);
        this.setState({ isLoading: false });
        if (401 === error.response.status) {
          this.fetchLiteData()
        } else {
          console.log(error);
        }
      })
    this.setState({ isLoading: false });
  }

  fetchLiteData() {
    this.setState({ isLoading: true })

    api.get('v2/mz/wa/composition_details_lite/' + this.props.id)
      .then(response => {
        const data = response.data
        this.setState({ data });
        this.setState({ isLoading: false })
      }).catch(error => {
        console.log(error);
        this.setState({ isLoading: false });
        if (401 === error.response.status) {
          this.setState({ allowed: false })
        } else {
          console.log(error);
        }
      })
    this.setState({ isLoading: false });
  }

  render() {
    const { data, isLoading, allowed } = this.state;
    const { id, isDialogOpened, closeDialog } = this.props;

    return (

      <Card variant="outlined" className='fullHeightCard'>
        <CardHeader
          title={<Typography gutterBottom variant="overline" component="h2">{this.props.rows === 5 ? t('MzComponentsPreviewTitle') : t('MzComponentsTitle')}</Typography>}
        />
        <CardContent sx={{ minHeight: 300, overflow: 'auto', maxHeight: 420 }}>
          <List>
            {
              // >>> LOADING STATE
              isLoading ? <SkeletonList /> :
                // >>> DATA STATE
                data.list && data.list.length > 0 ? data.list.map((obj, i) => (
                  i < this.props.rows &&
                  <ListItem key={obj.instrument_name}>
                    <ListItemAvatar><Avatar sx={{width: 30, height: 30}} src={getFlag(obj.country_name)} /></ListItemAvatar>
                    <ListItemText
                      primary={<Typography variant='subtitle2' className='bold'>{obj.ticker}</Typography>}
                      secondary={<Typography variant='caption' color={'textSecondary'} 
                      className='slim' component={'div'}
                      sx={{ whiteSpace: 'nowrap', maxWidth: '70%', overflow: "hidden", textOverflow: "ellipsis" }}>{obj.instrument_name}</Typography>} />
                    <ListItemSecondaryAction><Typography className='bold'>{obj.weight_val}</Typography></ListItemSecondaryAction>
                  </ListItem>

                ))
                  :
                  // >>> NO DATA STATE
                  allowed ? "no data"
                    :
                    // >>> NOT ALLOWED STATE
                    <Unauthorized />
            }
          </List>
        </CardContent>
      </Card>

    )
  }
}

export default DeskMzAllocationDetails;

// ---------------------
// UNAUTHORIZED CONTENT
// ---------------------
class Unauthorized extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      data: [],
    }
  }

  render() {
    return (
      <>
        <Box sx={{ display: 'flex' }}>
          <Box sx={{ p: 2, flex: '40%' }}><img src={'/img/401/Upgrade401.svg'} /></Box>
          <Box sx={{ p: 2, flex: '60%', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
            <Box><Typography variant='subtitle2'>{t('MzAllocationDetails401Title')}</Typography></Box>
            <Box sx={{ pb: 2 }}><Typography variant='body2'>{t('MzAllocationDetails401Text')}</Typography></Box>
            <Button disableElevation variant="contained" component={NavLink} to={'/plans'}>{t('MzAllocationDetails401Button')}</Button>
          </Box>
        </Box>
      </>
    )
  }
}